import { settings } from '@springtree/eva-sdk-core-settings';
export const defaultProductProperties = [
    'backend_id',
    'barcodes',
    'clothing_primary_color',
    'clothing_size',
    'configurable_properties',
    'currency_id',
    'custom_id',
    'display_price',
    'display_value',
    'is_sellable',
    'logical_level',
    'primary_image.blob',
    'product_description',
    'product_id',
    'product_media',
    'product_name',
    'product_requirements',
    'product_status',
    'product_types',
    'recommended_retail_price',
    'short_product_description',
    'unstackable',
];
// Register the default settings
//
export const SETTINGS_GROUP_NAME = 'evaReactRecoil';
const defaultSettings = {
    defaultProductProperties,
    defaultPageSize: 10,
    organizationUnitListLimit: 1000,
    currentOrderOptions: {
        IncludeAvailablePaymentMethods: true,
        IncludeAvailableRefundPaymentMethods: true,
        IncludeAvailableShippingMethods: true,
        IncludeCheckoutOptions: true,
        IncludeCustomerCustomFields: true,
        IncludeGiftCardBusinessRules: false,
        IncludeGiftWrapping: true,
        IncludeOrganizationUnitData: true,
        IncludePaymentTransactionActions: true,
        IncludePickProductOptions: false,
        IncludePrefigureDiscounts: false,
        IncludeProductRequirements: true,
        IncludeValidateShipment: true,
        ProductProperties: defaultProductProperties,
        RequiredFor: 7, // EVA.Core.RequiredFor.PlaceOrder + EVA.Core.RequiredFor.Payment + EVA.Core.RequiredFor.Ship,
    },
    shoppingCartOptions: {
        IncludeAvailablePaymentMethods: false,
        IncludeAvailableRefundPaymentMethods: false,
        IncludeAvailableShippingMethods: false,
        IncludeCheckoutOptions: false,
        IncludeCustomerCustomFields: true,
        IncludeGiftCardBusinessRules: false,
        IncludeGiftWrapping: true,
        IncludeOrganizationUnitData: true,
        IncludePaymentTransactionActions: false,
        IncludePickProductOptions: true,
        IncludePrefigureDiscounts: true,
        IncludeProductRequirements: true,
        IncludeValidateShipment: false,
        ProductProperties: defaultProductProperties,
        RequiredFor: 7, // EVA.Core.RequiredFor.PlaceOrder + EVA.Core.RequiredFor.Payment + EVA.Core.RequiredFor.Ship,
    },
};
settings.register(SETTINGS_GROUP_NAME, defaultSettings);
/**
 * Retrieves the settings for the EvaReactRecoil module
 *
 * @export
 * @returns {IEvaReactRecoilSettings}
 */
export function getReactRecoilSettings() {
    return settings.getGroup(SETTINGS_GROUP_NAME);
}
/**
 * Changes a setting for the EvaReactRecoil module
 *
 * @export
 * @param {string} settingName
 * @param {*} setting
 * @returns {ISettingsChange}
 */
export function setReactRecoilSetting(settingName, setting) {
    return settings.set(SETTINGS_GROUP_NAME, settingName, setting);
}
//# sourceMappingURL=settings.js.map